<script setup lang="ts">
import UIBrow from '@/components/ui/UIBrow.vue'
import UIInfoIcon from '@/components/ui/UIInfoIcon.vue'

defineProps<{
  headerText: string
  subheader?: string
}>()
</script>

<template>
  <div class="space-y-3">
    <div class="flex items-center space-x-1">
      <UIBrow :text="headerText" tag="h3" />
      <UIInfoIcon
        v-if="subheader"
        tooltip-direction="bottom"
        tooltip-alignment="right"
        :tooltip-text="subheader"
      />
    </div>

    <slot></slot>
  </div>
</template>
